module.exports = __webpack_public_path__ + "static/media/6-jan15june15.2c7a77e8.pdf";